import { forwardRef, useImperativeHandle } from "react";
import { Form } from "react-bootstrap";

function AvgDeliveryPrice(props, ref) {

    useImperativeHandle(ref, () => ({
        getName: getName,
        getType: getType,
        getTitle: getTitle,
        hasSettings: hasSettings,
        getSettings: getSettings,
        getDefaultOptions: ({ createOrUpdate }) => ({})
    }));

    const getName = () => {
        return 'Себестойност без ДДС';
    }

    const getType = () => {
        return 'avg_delivery_price';
    }

    const getTitle = () => {
        return 'Средно претеглена себестойност без ДДС за единица основно количество (кг, л или бр)';
    }

    const hasSettings = () => false;

    const getSettings = ({ state, setConfig, createOrUpdate }) => {
        return null;
    }

    return getName();
}

export default forwardRef(AvgDeliveryPrice)